import React from 'react';
import { createPortal } from 'react-dom';
import usePortal from './usePortal';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => {
  return {
    paper: {
      position: 'absolute',
      top: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100vw',
      height: '100vh',
      background: 'rgba(0, 0, 0, 0.4)',
      backdropFilter: 'blur(2px)',
      color: theme.palette.text.primary,
      overflow: 'hidden',
    },
  };
});
/**
 * @example
 * <Portal>
 *   <p>Thinking with portals</p>
 * </Portal>
 * @props
 * Pass the prop type='modal' to ensure that the contents of the modal
 * always remains the size of the modal. This is useful incase of creating subtasks with image croping
 */

const Portal = ({ id, children, creditCard }) => {
  const target = usePortal(id);
  const classes = useStyles(creditCard);

  const wrappedChildren = (
    <div className={classes.paper} style={{ zIndex: creditCard ? 999999 : 10 }}>
      {children}
    </div>
  );
  return createPortal(wrappedChildren, target);
};

export default Portal;
